module.exports = __webpack_public_path__ + "static/assets/e91249655f7ab40fcf43b4244e3abdd7.png";